import React, { FC, ReactNode } from 'react';

import { AccountRecognition } from '@shared/ui/Icon/Icons/AccountRecognition';
import { AddTask } from '@shared/ui/Icon/Icons/AddTask';
import { AddToEstimate } from '@shared/ui/Icon/Icons/AddToEstimate';
import { AiStars } from '@shared/ui/Icon/Icons/AiStars';
import { Alfa } from '@shared/ui/Icon/Icons/Alfa';
import { ArrowDown } from '@shared/ui/Icon/Icons/ArrowDown';
import { ArrowUp } from '@shared/ui/Icon/Icons/ArrowUp';
import { BrokenIcon } from '@shared/ui/Icon/Icons/BrokenIcon';
import { CarouselNext } from '@shared/ui/Icon/Icons/CarouselNext';
import { CarouselPrev } from '@shared/ui/Icon/Icons/CarouselPrev';
import { Group } from '@shared/ui/Icon/Icons/CarouselPrev/Group';
import { Checkboxes } from '@shared/ui/Icon/Icons/Checkboxes';
import { CheckedIcon } from '@shared/ui/Icon/Icons/CheckedIcon';
import { CheckIcon } from '@shared/ui/Icon/Icons/CheckIcon';
import { ChecklistIcon } from '@shared/ui/Icon/Icons/Checklist';
import { Close } from '@shared/ui/Icon/Icons/Close';
import { CommentsIcon } from '@shared/ui/Icon/Icons/Comments';
import { CopyIcon } from '@shared/ui/Icon/Icons/CopyIcon';
import { CrossIcon } from '@shared/ui/Icon/Icons/CrossIcon';
import { CursorInQr } from '@shared/ui/Icon/Icons/CursorInQr';
import { CustomJournalEvent } from '@shared/ui/Icon/Icons/CustomJournalEvent';
import { DecommissionIcon } from '@shared/ui/Icon/Icons/DecommissionIcon';
import { DocumentIcon } from '@shared/ui/Icon/Icons/DocumentIcon';
import { Doth } from '@shared/ui/Icon/Icons/Doth';
import { DoubleArrows } from '@shared/ui/Icon/Icons/DoubleArrows';
import { DraggableHandleIcon } from '@shared/ui/Icon/Icons/DraggableHandle';
import { Drawer } from '@shared/ui/Icon/Icons/Drawer';
import { EmployerSetting } from '@shared/ui/Icon/Icons/EmployerSetting';
import { EmptyReport } from '@shared/ui/Icon/Icons/EmptyReport';
import { Export } from '@shared/ui/Icon/Icons/Export';
import { Eye } from '@shared/ui/Icon/Icons/Eye';
import { FallbackError } from '@shared/ui/Icon/Icons/FallbackError';
import { FilesDelete } from '@shared/ui/Icon/Icons/FilesDelete';
import { FilesDownload } from '@shared/ui/Icon/Icons/FilesDownload';
import { FilesDropdownDots } from '@shared/ui/Icon/Icons/FilesDropdownDots';
import { FilesEdit } from '@shared/ui/Icon/Icons/FilesEdit';
import { Filter } from '@shared/ui/Icon/Icons/Filter';
import { FreeIcon } from '@shared/ui/Icon/Icons/FreeIcon';
import { GenerateEstimate } from '@shared/ui/Icon/Icons/GenerateEstimate';
import { GenerateMeasurementEng } from '@shared/ui/Icon/Icons/GenerateMeasurementEng';
import { GenerateMeasurementRus } from '@shared/ui/Icon/Icons/GenerateMeasurementRus';
import { GoLink } from '@shared/ui/Icon/Icons/GoLink';
import { HorizontalDots } from '@shared/ui/Icon/Icons/HorizontalDots';
import { House } from '@shared/ui/Icon/Icons/House';
import { ImgInput } from '@shared/ui/Icon/Icons/ImgInput';
import { Info } from '@shared/ui/Icon/Icons/Info';
import { InventoryCopyIcon } from '@shared/ui/Icon/Icons/InventoryCopyIcon';
import { InventoryDeleteIcon } from '@shared/ui/Icon/Icons/InventoryDeleteIcon';
import { InventoryMoveIcon } from '@shared/ui/Icon/Icons/InventoryMoveIcon';
import { InWorkIcon } from '@shared/ui/Icon/Icons/InWorkIcon';
import { IsCheckedIcon } from '@shared/ui/Icon/Icons/IsCheckedIcon';
import { IsErrorClose } from '@shared/ui/Icon/Icons/IsErrorClose';
import { OutlineLeftArrow } from '@shared/ui/Icon/Icons/OutlineLeftArrow';
import { OutlineRightArrow } from '@shared/ui/Icon/Icons/OutlineRightArrow';
import { Paintbrush } from '@shared/ui/Icon/Icons/Paintbrush';
import { PaperClipIcon } from '@shared/ui/Icon/Icons/PaperClipIcon';
import { PlayVideoIcon } from '@shared/ui/Icon/Icons/PlayVideoIcon';
import { PlusLarge } from '@shared/ui/Icon/Icons/PlusLarge';
import { ReceiptImg } from '@shared/ui/Icon/Icons/ReceiptImg';
import { Reload } from '@shared/ui/Icon/Icons/Reload';
import { RightArrow } from '@shared/ui/Icon/Icons/RightArrow';
import { SelectArrowThin } from '@shared/ui/Icon/Icons/SelectArrowThin';
import { SendIcon } from '@shared/ui/Icon/Icons/SendIcon';
import { SendNotesDeal } from '@shared/ui/Icon/Icons/SendNotesDeal';
import { Sort } from '@shared/ui/Icon/Icons/Sort';
import { Tinkoff } from '@shared/ui/Icon/Icons/Tinkoff';
import { Warning } from '@shared/ui/Icon/Icons/Warning';
import { XlsIcon } from '@shared/ui/Icon/Icons/XlsIcon';

import { ActiveEstimateCircle } from './Icons/ActiveEstimateCircle';
import { AddEmployee } from './Icons/AddEmployee';
import { ArchiveInformationBlock } from './Icons/ArchiveInformationBlock';
import { ArrowLeft } from './Icons/ArrowLeft';
import { ArrowRight } from './Icons/ArrowRight';
import { Attention } from './Icons/Attention';
import { AviExt } from './Icons/AviExt';
import { Back } from './Icons/Back';
import { Circle } from './Icons/Circle';
import { CloseModal } from './Icons/CloseModal';
import { CsvExt } from './Icons/CsvExt';
import { CustomTaskIcon } from './Icons/CustomTaskIcon';
import { Delete } from './Icons/Delete';
import { DeleteCard } from './Icons/DeleteCard';
import { DeleteImage } from './Icons/DeleteImage';
import { DeleteInformationBlock } from './Icons/DeleteInformationBlock';
import { Delivery } from './Icons/Delivery';
import { DocExt } from './Icons/DocExt';
import { Download } from './Icons/Download';
import { DownloadAttachment } from './Icons/DownloadAttachment';
import { DownloadDocument } from './Icons/DownloadDocument';
import { DownloadReconciliation } from './Icons/DownloadReconciliation';
import { DraftEstimateCircle } from './Icons/DraftEstimateCircle';
import { Edit } from './Icons/Edit';
import { EditInformationBlock } from './Icons/EditInformationBlock';
import { Estimate } from './Icons/Estimate';
import { FileInput } from './Icons/FileInput';
import { FileItemPlaceholder } from './Icons/FileItemPlaceholder';
import { ForemanIcon } from './Icons/ForemanIcon';
import { GenerateMeasurement } from './Icons/GenerateMeasurement';
import { GiftIcon } from './Icons/Gift';
import { IconExecutor } from './Icons/IconExecuter';
import { IconWatcher } from './Icons/IconWatcher';
import { IfcExt } from './Icons/IfcExt';
import { InProcess } from './Icons/InProcess';
import { InWeeks } from './Icons/InWeeks';
import { LinkIcon } from './Icons/LinkIcon';
import { Location } from './Icons/Location';
import { ManagerIcon } from './Icons/ManagerIcon';
import { Materials } from './Icons/Materials';
import { MoreActionsDots } from './Icons/MoreActionsDots';
import { MovExt } from './Icons/MovExt';
import { Mp3Ext } from './Icons/Mp3Ext';
import { Mp4Ext } from './Icons/Mp4Ext';
import { NavigationNext } from './Icons/NavigationNext';
import { NavigationPrev } from './Icons/NavigationPrev';
import { NoFoundTasks } from './Icons/NoFoundTasks';
import { Overdue } from './Icons/Overdue';
import { Payment } from './Icons/Payment';
import { PdfExt } from './Icons/PdfExt';
import { Plus } from './Icons/Plus';
import { PopupWarning } from './Icons/PopupWarning';
import { PptExt } from './Icons/PptExt';
import { Profile } from './Icons/Profile';
import { ProfileBigSize } from './Icons/ProfileBigSize';
import { PurchaserIcon } from './Icons/PurchaserIcon';
import { Question } from './Icons/Question';
import { RarExt } from './Icons/RarExt';
import { Redirect } from './Icons/Redirect';
import { ResetFilters } from './Icons/ResetFilters';
import { ResetInput } from './Icons/ResetInput';
import { Search } from './Icons/Search';
import { SelectArrow } from './Icons/SelectArrow';
import { SevenZExt } from './Icons/sevenZExt';
import { SmetterLogo } from './Icons/SmetterLogo';
import { SmtrExt } from './Icons/SmtrExt';
import { SystemTaskIcon } from './Icons/SystemTaskIcon';
import { TabError } from './Icons/TabError';
import { TaskAuthorIcon } from './Icons/TaskAuthorIcon';
import { TaskCalendar } from './Icons/TaskCalendar';
import { TaskColor } from './Icons/TaskColor';
import { TaskDelete } from './Icons/TaskDelete';
import { TaskDescription } from './Icons/TaskDescription';
import { TaskEstimate } from './Icons/TaskEstimate';
import { TaskExecutor } from './Icons/TaskExecutor';
import { TaskExecutorsEdit } from './Icons/TaskExecutorsEdit';
import { TaskFilter } from './Icons/TaskFilter';
import { TaskObservers } from './Icons/TaskObservers';
import { TaskProjects } from './Icons/TaskProjects';
import { TaskQuestion } from './Icons/TaskQuestion';
import { TaskSearch } from './Icons/TaskSearch';
import { TaskSort } from './Icons/TaskSort';
import { TaskTags } from './Icons/TaskTags';
import { TaskTypes } from './Icons/TaskTypes';
import { TaskWatchers } from './Icons/TaskWatchers';
import { Today } from './Icons/Today';
import { TxtExt } from './Icons/TxtExt';
import { UnArchiveInformationBlock } from './Icons/UnArchiveInformationBlock';
import { WhitePlus } from './Icons/WhitePlus';
import { Work } from './Icons/Work';
import { XlsExt } from './Icons/XlsExt';
import { XmlExt } from './Icons/XmlExt';
import { ZipExt } from './Icons/ZipExt';

interface IconProps extends React.SVGProps<SVGSVGElement> {
    iconName?: string;
    fill?: string;
    color?: string;
    width?: number;
    height?: number;
    thickness?: number;
    background?: string;
}

export const Icon: FC<IconProps> = ({ iconName, fill, color, ...rest }) => {
    if (!iconName) return null;

    const iconMapping: Record<string, ReactNode> = {
        delete: <Delete fill={fill} {...rest} />,
        deleteImage: <DeleteImage />,
        drawer: <Drawer width={rest.width} height={rest.height} fill={fill} {...rest} />,
        edit: <Edit />,
        download: <Download color={color} {...rest} />,
        doubleArrows: <DoubleArrows {...rest} />,
        back: <Back />,
        arrowLeft: <ArrowLeft />,
        arrowRight: <ArrowRight />,
        editInformationBlock: <EditInformationBlock />,
        archiveInformationBlock: <ArchiveInformationBlock />,
        unArchiveInformationBlock: <UnArchiveInformationBlock />,
        deleteInformationBlock: <DeleteInformationBlock />,
        closeModal: <CloseModal fill={fill} width={rest.width} height={rest.height} {...rest} />,
        plus: <Plus fill={fill} width={rest.width} height={rest.height} {...rest} />,
        plusLarge: <PlusLarge {...rest} />,
        search: <Search {...rest} fill={fill} />,
        location: <Location />,
        downloadDocument: <DownloadDocument {...rest} fill={fill} />,
        draftEstimateCircle: <DraftEstimateCircle />,
        activeEstimateCircle: <ActiveEstimateCircle />,
        question: <Question fill={fill} />,
        attention: <Attention />,
        circle: <Circle fill={fill} />,
        profile: <Profile />,
        tabError: <TabError />,
        downloadReconciliation: <DownloadReconciliation />,
        whitePlus: <WhitePlus />,
        deleteCard: <DeleteCard />,
        managerIcon: <ManagerIcon />,
        foremanIcon: <ForemanIcon />,
        purchaserIcon: <PurchaserIcon />,
        profileBigSize: (
            <ProfileBigSize width={rest.width} height={rest.height} background={rest.background} />
        ),
        smetterLogo: <SmetterLogo />,
        delivery: <Delivery />,
        estimate: <Estimate />,
        payment: <Payment />,
        materials: <Materials />,
        work: <Work />,
        selectArrow: <SelectArrow fill={fill} />,
        selectArrowThin: <SelectArrowThin fill={fill} />,
        navigationPrev: <NavigationPrev />,
        navigationNext: <NavigationNext />,
        executor: <IconExecutor />,
        watcher: <IconWatcher />,
        overdue: <Overdue />,
        inProcess: <InProcess />,
        today: <Today />,
        inWeeks: <InWeeks />,
        redirect: <Redirect />,
        taskCalendar: <TaskCalendar fill={fill} />,
        taskColor: <TaskColor fill={fill} />,
        taskFilter: <TaskFilter fill={fill} {...rest} />,
        taskProjects: <TaskProjects fill={fill} />,
        taskTypes: <TaskTypes fill={fill} />,
        taskDescription: <TaskDescription fill={fill} />,
        taskTags: <TaskTags fill={fill} {...rest} />,
        taskExecutor: <TaskExecutor fill={fill} />,
        taskAuthor: <TaskAuthorIcon fill={fill} />,
        taskEstimate: <TaskEstimate fill={fill} />,
        taskWatchers: <TaskWatchers fill={fill} />,
        taskIconLink: <LinkIcon fill={fill} />,
        taskDelete: <TaskDelete fill={fill} {...rest} />,
        taskExecutorsEdit: <TaskExecutorsEdit fill={fill} {...rest} />,
        taskSearch: <TaskSearch fill={fill} />,
        customTaskIcon: <CustomTaskIcon fill={fill} />,
        systemTaskIcon: <SystemTaskIcon fill={fill} />,
        taskSort: <TaskSort fill={fill} />,
        resetFilters: <ResetFilters fill={fill} />,
        taskQuestion: <TaskQuestion />,
        resetInput: <ResetInput />,
        noFoundTasks: <NoFoundTasks fill={fill} {...rest} />,
        popupWarning: <PopupWarning fill={fill} {...rest} />,
        fileInput: <FileInput className={rest.className} {...rest} />,
        imgInput: <ImgInput className={rest.className} {...rest} />,
        fileItemPlaceholder: <FileItemPlaceholder {...rest} />,
        moreActionsDots: <MoreActionsDots fill={fill} />,
        downloadAttachment: (
            <DownloadAttachment fill={fill} width={rest.width} height={rest.height} />
        ),
        tinkoff: <Tinkoff width={rest.width} height={rest.height} />,
        alfa: <Alfa width={rest.width} height={rest.height} />,
        sendNotesDeal: <SendNotesDeal fill={fill} width={rest.width} height={rest.height} />,
        taskObservers: <TaskObservers fill={fill} />,
        filesDelete: <FilesDelete fill={fill} {...rest} />,
        filesDownload: <FilesDownload fill={fill} {...rest} />,
        filesDropdownDots: <FilesDropdownDots fill={fill} {...rest} />,
        filesEdit: <FilesEdit fill={fill} {...rest} />,
        filter: <Filter {...rest} />,
        sort: <Sort {...rest} />,
        pdfFile: <PdfExt {...rest} />,
        docFile: <DocExt {...rest} />,
        xlsFile: <XlsExt {...rest} />,
        xmlFile: <XmlExt {...rest} />,
        ifcFile: <IfcExt {...rest} />,
        pptFile: <PptExt {...rest} />,
        csvFile: <CsvExt {...rest} />,
        txtFile: <TxtExt {...rest} />,
        mp4File: <Mp4Ext {...rest} />,
        movFile: <MovExt {...rest} />,
        mp3File: <Mp3Ext {...rest} />,
        smtrFile: <SmtrExt {...rest} />,
        sevenZFile: <SevenZExt {...rest} />,
        rarFile: <RarExt {...rest} />,
        zipFile: <ZipExt {...rest} />,
        aviFile: <AviExt {...rest} />,
        addEmployee: <AddEmployee />,
        addToEstimate: <AddToEstimate />,
        employerSetting: <EmployerSetting />,
        addTask: <AddTask />,
        fallbackError: <FallbackError />,
        customJournalEvent: <CustomJournalEvent />,
        carouselPrev: <CarouselPrev />,
        carouselNext: <CarouselNext {...rest} fill={fill} />,
        divider: <FallbackError />,
        cross: <CrossIcon fill={fill} {...rest} />,
        paintbrush: <Paintbrush fill={fill} {...rest} />,
        doth: <Doth fill={fill} {...rest} />,
        xlsIcon: <XlsIcon />,
        eye: <Eye />,
        cursorInQr: <CursorInQr fill={fill} {...rest} />,
        export: <Export fill={fill} {...rest} />,
        goLink: <GoLink fill={fill} {...rest} />,
        group: <Group fill={fill} {...rest} />,
        arrowDown: <ArrowDown fill={fill} {...rest} />,
        arrowUp: <ArrowUp fill={fill} {...rest} />,
        rightArrow: <RightArrow fill={fill} {...rest} />,
        check: <CheckIcon {...rest} />,
        warning: <Warning {...rest} />,
        document: <DocumentIcon {...rest} fill={fill} />,
        draggableHandle: <DraggableHandleIcon {...rest} fill={fill} />,
        isChecked: <IsCheckedIcon {...rest} />,
        isErrorClose: <IsErrorClose {...rest} />,
        generateMeasurement: <GenerateMeasurement fill={fill} {...rest} />,
        generateEstimate: <GenerateEstimate fill={fill} {...rest} />,
        generateMeasurementRus: <GenerateMeasurementRus fill={fill} {...rest} />,
        generateMeasurementEng: <GenerateMeasurementEng fill={fill} {...rest} />,
        accountRecognition: <AccountRecognition fill={fill} {...rest} />,
        aiStars: <AiStars fill={fill} {...rest} />,
        playVideo: <PlayVideoIcon {...rest} />,
        close: <Close fill={fill} {...rest} width={rest.width} height={rest.height} />,
        house: <House fill={fill} {...rest} width={rest.width} height={rest.height} />,
        info: <Info fill={fill} {...rest} width={rest.width} height={rest.height} />,
        freeIcon: <FreeIcon fill={fill} {...rest} width={rest.width} height={rest.height} />,
        inWorkIcon: <InWorkIcon fill={fill} {...rest} width={rest.width} height={rest.height} />,
        brokenIcon: <BrokenIcon fill={fill} {...rest} width={rest.width} height={rest.height} />,
        decommissionIcon: (
            <DecommissionIcon fill={fill} {...rest} width={rest.width} height={rest.height} />
        ),
        horizontalDots: (
            <HorizontalDots fill={fill} {...rest} width={rest.width} height={rest.height} />
        ),
        outlineRightArrow: <OutlineRightArrow fill={fill} {...rest} />,
        outlineLeftArrow: <OutlineLeftArrow fill={fill} {...rest} />,
        checkboxes: <Checkboxes fill={fill} {...rest} />,
        reload: <Reload fill={fill} {...rest} />,
        emptyReport: <EmptyReport fill={fill} {...rest} />,
        copy: <CopyIcon fill={fill} {...rest} />,
        checked: <CheckedIcon fill={fill} {...rest} />,
        checklist: <ChecklistIcon fill={fill} {...rest} />,
        paperClip: <PaperClipIcon fill={fill} {...rest} />,
        send: <SendIcon fill={fill} {...rest} />,
        comments: <CommentsIcon fill={fill} {...rest} />,
        receiptImg: <ReceiptImg fill={fill} {...rest} />,
        gift: <GiftIcon fill={fill} {...rest} />,
        inventoryMove: <InventoryMoveIcon fill={fill} {...rest} />,
        inventoryCopy: <InventoryCopyIcon fill={fill} {...rest} />,
        inventoryDelete: <InventoryDeleteIcon fill={fill} {...rest} />,
    };
    return iconMapping[iconName] ? iconMapping[iconName] : <div />;
};
